import tagsApi from '@/api/tags';

const state = {
    data: null,
    tagsCreated: null,
    tagsUpdated: null,
    tagsClientUpdated: null,
    isLoading: false,
    validationErrors: null,
}

export const mutationTypes = {
    tagsListStart: '[tags] Get list tags start',
    tagsListSuccess: '[tags] Get list tags success',
    tagsListFailure: '[tags] Get list tags failure',

    tagsFullListStart: '[tags] Get full list tags start',
    tagsFullListSuccess: '[tags] Get full list tags success',
    tagsFullListFailure: '[tags] Get full list tags failure',

    tagsAddStart: '[tags] Create tags start',
    tagsAddSuccess: '[tags] Create tags success',
    tagsAddFailure: '[tags] Create tags failure',

    tagsUpdateStart: '[tags] Update tags start',
    tagsUpdateSuccess: '[tags] Update tags success',
    tagsUpdateFailure: '[tags] Update tags failure',

    tagsClientUpdateStart: '[tags] Client update tags start',
    tagsClientUpdateSuccess: '[tags] Client update tags success',
    tagsClientUpdateFailure: '[tags] Client update tags failure',
}

export const tagsActionTypes = {
    tagsList: '[tags] Get list tags',
    tagsFullList: '[tags] Get full list tags',
    tagsAdd: '[tags] Create tags',
    tagsUpdate: '[tags] Update tags',
    tagsClientUpdate: '[tags] Client update tags'
}

const mutations = {
    [mutationTypes.tagsListStart](state) {
        state.isLoading = true
        state.data = null
    },
    [mutationTypes.tagsListSuccess](state, payload) {
        state.isLoading = false
        state.data = payload
        state.validationErrors = null
    },
    [mutationTypes.tagsListFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.tagsFullListStart](state) {
        state.isLoading = true
        state.data = null
    },
    [mutationTypes.tagsFullListSuccess](state, payload) {
        state.isLoading = false
        state.data = payload
        state.validationErrors = null
    },
    [mutationTypes.tagsFullListFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.tagsAddStart](state) {
        state.isLoading = true
        state.tagsCreated = null
    },
    [mutationTypes.tagsAddSuccess](state, payload) {
        state.isLoading = false
        state.tagsCreated = payload
        state.validationErrors = null
    },
    [mutationTypes.tagsAddFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.tagsUpdateStart](state) {
        state.isLoading = true
        state.tagsUpdated = null
    },
    [mutationTypes.tagsUpdateSuccess](state, payload) {
        state.isLoading = false
        state.tagsUpdated = payload
        state.validationErrors = null
    },
    [mutationTypes.tagsUpdateFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.tagsClientUpdateStart](state) {
        state.isLoading = true
        state.tagsClientUpdated = null
    },
    [mutationTypes.tagsClientUpdateSuccess](state, payload) {
        state.isLoading = false
        state.tagsClientUpdated = payload
        state.validationErrors = null
    },
    [mutationTypes.tagsClientUpdateFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },
}

const actions = {
    [tagsActionTypes.tagsList](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.tagsListStart)
            tagsApi
                .tagsList(data)
                .then(response => {
                    context.commit(mutationTypes.tagsListSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.tagsListFailure,response)
                })
        })
    },
    [tagsActionTypes.tagsFullList](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.tagsFullListStart)
            tagsApi
                .tagsFullList(data)
                .then(response => {
                    context.commit(mutationTypes.tagsFullListSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.tagsFullListFailure,response)
                })
        })
    },
    [tagsActionTypes.tagsAdd](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.tagsAddStart)
            tagsApi
                .tagsAdd(data)
                .then(response => {
                    context.commit(mutationTypes.tagsAddSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.tagsAddFailure,response)
                })
        })
    },
    [tagsActionTypes.tagsUpdate](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.tagsUpdateStart)
            tagsApi
                .tagsUpdate(data)
                .then(response => {
                    context.commit(mutationTypes.tagsUpdateSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.tagsUpdateFailure,response)
                })
        })
    },
    [tagsActionTypes.tagsClientUpdate](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.tagsClientUpdateStart)
            tagsApi
                .tagsClientUpdate(data)
                .then(response => {
                    context.commit(mutationTypes.tagsClientUpdateSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.tagsClientUpdateFailure,response)
                })
        })
    }
}

export default {
    state,
    actions,
    mutations
}